// This file was auto-generated by Fern from our API Definition.
export const PendingInputState = {
    Pending: "pending",
    Promoted: "promoted",
    Removed: "removed",
};
